document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const styleId = 'bss-b2b-visible-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          [bss-b2b-variant-price], 
          [bss-b2b-product-price], 
          [bss-b2b-cart-item-key][bss-b2b-item-original-price], 
          [bss-b2b-cart-item-key][bss-b2b-final-line-price], 
          [bss-b2b-cart-item-key] [bss-b2b-item-original-price], 
          [bss-b2b-cart-item-key] [bss-b2b-final-line-price], 
          [bss-b2b-cart-total-price] {
            visibility: visible !important;
          }
        `;
        document.head.appendChild(style);
      }
    }, 2000);

    const hideElementsByClass = (parent, className) => {
        if (!parent) 
            return;
        
        parent.querySelectorAll(className).forEach(element => {
            element.style.display = "none";
        });
    };
    const handlePriceVisibility = () => {
        //parent has TD
        const priceTax = document.querySelector("[bss-b2b-main-product-form] [bss-b2b-product-id]");
        //parent no TD
        const priceTaxQB = document.querySelector("div.bss-b2b-qty-table-wrapper");
        if (! priceTax || ! priceTaxQB) 
            return;
        
        const hasNoVatClass = priceTax.querySelector(".bss-b2b-price-no-vat");
        const hasVatClass = priceTax.querySelector(".bss-b2b-price-has-vat");
        if (hasNoVatClass && hasVatClass) 
            return;
        
        if (! hasNoVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-no-vat");
        
        if (! hasVatClass) 
            hideElementsByClass(priceTaxQB, ".bss-b2b-price-has-vat");
        
    };
    const observer = new MutationObserver(() => handlePriceVisibility());
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    handlePriceVisibility();
});

setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.classList.contains("dbtfy-quick-view__content")) {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)